import { render, staticRenderFns } from "./RuleSetup.vue?vue&type=template&id=6a4e61a3&"
import script from "./RuleSetup.vue?vue&type=script&lang=ts&"
export * from "./RuleSetup.vue?vue&type=script&lang=ts&"
import style0 from "./RuleSetup.vue?vue&type=style&index=0&id=6a4e61a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports